import type { LoginContact } from '@/service/otpAuthService';

/** "Can't sign in? Find your plan" — recover access with the order's invoice. */
export const FIND_PLAN_PATH = '/customer-login/find-plan';

export type ContactChannel = LoginContact['channel'];

export const VALID_MOBILE = /^[6-9]\d{9}$/;
export const VALID_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** "98765 43210" while typing. */
export const formatMobile = (digits: string) => (digits.length > 5 ? `${digits.slice(0, 5)} ${digits.slice(5)}` : digits);

/** The contact as the API wants it, or undefined until it's valid. */
export function toContact(channel: ContactChannel, mobile: string, email: string): LoginContact | undefined {
  if (channel === 'mobile') return VALID_MOBILE.test(mobile) ? { channel, mobile } : undefined;
  const trimmed = email.trim();
  return VALID_EMAIL.test(trimmed) ? { channel, email: trimmed } : undefined;
}

/** "+91 98765 43210" or "priya@example.com". */
export const displayContact = (c: LoginContact) => (c.channel === 'mobile' ? `+91 ${formatMobile(c.mobile)}` : c.email);

/** Where the code goes, for "Sent … to …" lines. */
export const deliveryLabel = (c: LoginContact) => (c.channel === 'mobile' ? 'on WhatsApp' : 'by email');

/** Error to show under the field, once the customer has typed enough to judge. */
export function contactError(channel: ContactChannel, mobile: string, email: string, touched: boolean): string | undefined {
  if (channel === 'mobile') {
    const invalid = (mobile.length === 10 && !VALID_MOBILE.test(mobile)) || (touched && mobile.length > 0 && mobile.length < 10);
    return invalid ? 'Enter a valid 10-digit mobile number' : undefined;
  }
  return touched && email.trim() && !VALID_EMAIL.test(email.trim()) ? 'Enter a valid email address' : undefined;
}
